function getEvents(pageId, largeHeaderId) {
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium"],
        target: {
          id: `${pageId}|${largeHeaderId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${largeHeaderId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1692094634264,
      },
      "e-2": {
        id: "e-2",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a-2", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["small", "tiny"],
        target: {
          id: `${pageId}|${largeHeaderId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${largeHeaderId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-2-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1692094643797,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Layout 424 Heading [Scroll] [Desktop]",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      yValue: 0,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-2",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-3",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      yValue: 0,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-17",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-1",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "64787764-61a8-1571-ed0f-6ce5f468e857",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 22,
                actionItems: [
                  {
                    id: "a-n-4",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      yValue: -100,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-5",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-6",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-7",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      yValue: -100,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-8",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      yValue: -100,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-18",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-1",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "64787764-61a8-1571-ed0f-6ce5f468e857",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-19",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-2",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "9d511799-d8ee-8f64-62d3-a7d52f985a53",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 44,
                actionItems: [
                  {
                    id: "a-n-9",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      yValue: -200,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-10",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-11",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      yValue: -200,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-12",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-13",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-4",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb766f",
                        ],
                      },
                      yValue: -200,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-20",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-2",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "9d511799-d8ee-8f64-62d3-a7d52f985a53",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-21",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-3",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "6b64fde8-f9bb-17e8-9136-8c4b05e5b8e8",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 66,
                actionItems: [
                  {
                    id: "a-n-14",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      yValue: -300,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-15",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-16",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-4",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb766f",
                        ],
                      },
                      yValue: -300,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-22",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-3",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "6b64fde8-f9bb-17e8-9136-8c4b05e5b8e8",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1691744175161,
      },
      "a-2": {
        id: "a-2",
        title: "Layout 424 Heading [Scroll] [Mobile]",
        continuousParameterGroups: [
          {
            id: "a-2-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-2-n",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      yValue: 0,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-2",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-3",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      yValue: 0,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-17",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-1",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "64787764-61a8-1571-ed0f-6ce5f468e857",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 16,
                actionItems: [
                  {
                    id: "a-2-n-4",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      yValue: -100,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-5",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-1",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7670",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-6",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-7",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      yValue: -100,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-8",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      yValue: -100,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-18",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-1",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "64787764-61a8-1571-ed0f-6ce5f468e857",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-19",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-2",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "9d511799-d8ee-8f64-62d3-a7d52f985a53",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 32,
                actionItems: [
                  {
                    id: "a-2-n-9",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      yValue: -200,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-10",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-2",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7671",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-11",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      yValue: -200,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-12",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-13",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-4",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb766f",
                        ],
                      },
                      yValue: -200,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-20",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-2",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "9d511799-d8ee-8f64-62d3-a7d52f985a53",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-21",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-3",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "6b64fde8-f9bb-17e8-9136-8c4b05e5b8e8",
                        ],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 48,
                actionItems: [
                  {
                    id: "a-2-n-14",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      yValue: -300,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-15",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-3",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7674",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                  {
                    id: "a-2-n-16",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector: ".layout424_heading.heading-4",
                        selectorGuids: [
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb7669",
                          "fe73d9df-d831-ad18-4ceb-88a8e3fb766f",
                        ],
                      },
                      yValue: -300,
                      xUnit: "PX",
                      yUnit: "%",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-2-n-22",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        selector:
                          ".layout424_background-image-container.background-image-container-3",
                        selectorGuids: [
                          "94286e2f-c2af-fcb3-f228-042df43026ee",
                          "6b64fde8-f9bb-17e8-9136-8c4b05e5b8e8",
                        ],
                      },
                      value: 0,
                      unit: "",
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
